import loadable from '@loadable/component'

export const ApplicableModels = loadable(() => import('./ApplicableModels'))
export type { ApplicableModelsProps } from './ApplicableModels'
